import {
  getAsync,
  postAsync,
  putAsync,
  deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/account";
const usersEndpoint = endpoint + "/users";
const rolesEndpoint = endpoint + "/roles";
const permissionsEndpoint = endpoint + "/permissions";

/// =============== USERS ========================

// GET all users
export async function getUsersListAsync() {
  return await getAsync(`${usersEndpoint}`);
}

// Get a user by id
export async function getUserAsync(userId) {
  return await getAsync(`${usersEndpoint}/${userId}`);
}

// CREATE a new user
export async function createUserAsync(model) {
  return await postAsync(`${usersEndpoint}`, model);
}

// UPDATE a user
export async function updateUserAsync(userId, model) {
  return await putAsync(`${usersEndpoint}/${userId}`, model);
}

// DELETE a user
export async function deleteUserAsync(userId) {
  return await deleteAsync(`${usersEndpoint}/${userId}`);
}

/// =============== ROLES ========================

// GET all roles
export async function getRolesListAsync() {
  return await getAsync(`${rolesEndpoint}`);
}

// GET a role by id
export async function getRoleAsync(roleId) {
  return await getAsync(`${rolesEndpoint}/${roleId}`);
}

// CREATE a new role
export async function createRoleAsync(model) {
  return await postAsync(`${rolesEndpoint}`, model);
}

// UPDATE a role
export async function updateRoleAsync(roleId, model) {
  return await putAsync(`${rolesEndpoint}/${roleId}`, model);
}

// DELETE a role
export async function deleteRoleAsync(roleId) {
  return await deleteAsync(`${rolesEndpoint}/${roleId}`);
}

/// =============== PERMISSIONS ======================

// GET all permissions
export async function getAllPermissionsAsync() {
  return await getAsync(`${permissionsEndpoint}`);
}